import { BASE_ENDPOINT } from "../../endpoint";

export const getPlanFeatures = async (TOKEN, planId) => {
  try {
    const response = await fetch(
      `${BASE_ENDPOINT}/api/payrollplans/${planId}/features`,
      {
        method: "GET",
        headers: {
          Authorization: TOKEN ? `Bearer ${TOKEN}` : undefined,
          "Content-Type": "application/json",
        },
      },
    );

    const res = await response.json();
    if (!response.ok) {
      console.error("Error fetching plan features:", res);
      throw new Error(res.message || "Failed to fetch plan features");
    }

    if (Array.isArray(res)) return res;
    if (Array.isArray(res?.data)) return res.data;
    return res?.data ?? [];
  } catch (error) {
    console.error("API fetch error:", error);
    throw error;
  }
};
